import {Component, OnInit} from '@angular/core';
import {DataStorageService} from '../../shared/data-storage.service';
import {AdminDashboardService} from './admin-dashboard.service';
import {NGXLogger} from 'ngx-logger';
import {
  ViewAdminDashboard, ViewAdminDashboardResponse, ViewAdminTxnsDashboardGraphDataResponse,
  AdminPaymentKeyperFormanceIndicatorView, AdminTxnsStaticsView, AdminTxnsRegBillerView, BillerPerformance, TopBiller,
  TopBillerResp, AdminPaymentSuccessRateView, AdminPaymentTxnsAmountView, AdminPaymentTxnsAmountViewResp,
  NumberOfVisitors, InputOfVisitors, AssistedPerformance
} from './view-admin-dashboard';
import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {LeftMenu} from '../../shared/leftmenu/LeftMenu';
import {LoaderService} from '../../shared/loader/loader.service';
import {TranslateService} from '../../../../node_modules/@ngx-translate/core';
import {Subscription} from '../../../../node_modules/rxjs';
import {transactionAmountColor, transactionColor} from '../biller-dashboard/biller-dashboard.component';
import {DashboardService} from '../dashboard.service';


@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css'],
})
export class AdminDashboardComponent implements OnInit {
  constructor(
    private dataStorageService: DataStorageService,
    private serviceAdmin: AdminDashboardService,
    private logger: NGXLogger,
    private router: Router,
    private pipe: DatePipe,
    private leftMenu: LeftMenu,
    private loaderService: LoaderService,
    private dashboardService: DashboardService,
    private readonly translate: TranslateService
  ) {
  }

  public barChartType: string = 'bar';
  public barChartLegend: boolean = true;
  isRefresh: boolean = false;
  barChartOptions = {
    tooltips: {
      intersect: false,
      mode: 'index'
    },
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'No. of Transactions',
            fontSize: 16,
            fontColor: '#8f3e92',
          },
          position: 'left',
          id: '1',
          type: 'linear',
          ticks: this.dashboardService.customTicks,
        },
        {
          scaleLabel: {
            display: true,
            labelString: 'Total Amount (in BDT)',
            fontSize: 16,
            fontColor: '#88c133',
          },
          position: 'right',
          id: '2',
          type: 'linear',
          ticks: this.dashboardService.customTicks,
        },
      ],
    },
  }; //for skeleton of bars

  public barChartColors: Array<any> = [
    {
      backgroundColor: transactionColor,
      borderColor: transactionColor,
      pointBackgroundColor: transactionColor,
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: transactionColor,
    },
    {
      backgroundColor: transactionAmountColor,
      borderColor: transactionAmountColor,
      pointBackgroundColor: transactionAmountColor,
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: transactionAmountColor,
    },
  ]; // for the skin of bars
  viewAdminDashboardResponse: ViewAdminDashboardResponse;
  viewAdminTxnsDashboardGraphDataResponse: ViewAdminTxnsDashboardGraphDataResponse;
  viewAdminDashboard: ViewAdminDashboard;
  adminPaymentKeyperFormanceIndicatorView: AdminPaymentKeyperFormanceIndicatorView;
  adminTxnsStaticsView: AdminTxnsStaticsView;
  adminTxnsRegBillerView: AdminTxnsRegBillerView;
  billerPerformance: BillerPerformance;
  assistedPerformance: AssistedPerformance;
  topBillerResp: TopBillerResp;
  adminPaymentSuccessRateView: AdminPaymentSuccessRateView;
  adminPaymentTxnsAmountViewResp: AdminPaymentTxnsAmountViewResp;
  adminPaymentTxnsAmountView: AdminPaymentTxnsAmountView;
  inputOfVisitors: InputOfVisitors;

  numberOfVisitors: NumberOfVisitors;

  public barChartData: any[];
  public barChartLabels: string[];
  public pieChartData: number[];
  public barChart2Data: any[];
  public barChart2Labels: string[];
  public barChartAssistedData: any[];
  public barChartAssistedLabels: string[];
  public hollowLineChartData: Array<any>;
  public hollowLineChartLabels: Array<any>;
  public LinePIChartData: Array<any>;
  public LinePIChartLabels: Array<any>;
  public linePISFChartData: Array<any>;
  public linePISFChartLabels: Array<any>;
  public lineSFChartLabels: Array<any>;
  public lineSFChartData: Array<any>;
  public lineChartData: Array<any>;
  public lineChartLabels: Array<any>;
  color: string = '#';

  loaderOff: number;
  numberOfTrans = 0;
  transactionAmount = 0;
  totalTxsnNo: number;
  totalTxsnAmnt: number;
  textHeading: string;

  activeAllFlag: boolean = false;
  activeYearFlag: boolean = false;
  activeLastYearFlag: boolean = false;
  activeMonthFlag: boolean = false;
  activeWeekFlag: boolean = false;
  activeTodayFlag: boolean = false;

  customFlag: boolean = false;

  isDataRefresh: boolean = false;
  isRecentTransaction: boolean = false;
  isTopBillerAvail: boolean = false;

  isGetTxsnUpdate: Boolean = false;
  isTxsnReportUpdate: boolean = false;
  isKeyPerUpdate: boolean = false;
  isTxsnStaticsUpdate: boolean = false;
  isRegCitizenUpdate: boolean = false;
  isRegBillerUpdate: boolean = false;
  isTopRecordUpdate: boolean = false;
  isPITxsnUpdate: boolean = false;
  isPMTxsnUpdate: boolean = false;
  isPISuccFailUpdate: boolean = false;
  isPMSuccFailUpdate: boolean = false;
  idBillerPerUpdate: boolean = false;
  isAssistedUpdate: boolean = false;
  isVisitorUpdate: boolean = false;
  subscription: Subscription;
  lang: string;
  disablePrev: boolean = false;
  disableNext: boolean = true;
  disableNextWeek: boolean = true;
  disableNextMonth: boolean = true;
  disableNextYear: boolean = true;

  minDate: Date = new Date('2019-10-01');
  today: Date = new Date();
  currentDate: Date = new Date();
  currentWeekDate: Date = new Date();
  currentMonthDate: Date = new Date();
  currentYearDate: Date = new Date();

  filterOptions = [
    {
      title: 'all',
      value: 'all',
    },
    {
      title: 'daily',
      value: 'today',
    },
    {
      title: 'weekly',
      value: 'week',
    },
    {
      title: 'monthly',
      value: 'month',
    },
    {
      title: 'yearly',
      value: 'year',
    },
  ];

  monthList = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  yearList = [];

  selectedOption = 'today';
  selectedMonth = this.currentMonthDate.getMonth();
  selectedMonthYear = this.currentMonthDate.getFullYear();
  selectedYear = this.currentYearDate.getFullYear();

  // currentMonth: string;

  ngOnInit() {
    for (let i = 2019; i <= 2024; i++) {
      this.yearList.push(i);
    }
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      //this.logger.debug('data lang is ' + data);
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem('lang');
      }
      this.translate.use(this.lang);
    });
    window.scroll(0, 0);
    this.dataStorageService.setTabData('tabAdminDashboard');
    this.viewAdminDashboardResponse = new ViewAdminDashboardResponse();
    this.viewAdminTxnsDashboardGraphDataResponse =
      new ViewAdminTxnsDashboardGraphDataResponse();
    this.adminPaymentKeyperFormanceIndicatorView =
      new AdminPaymentKeyperFormanceIndicatorView();
    this.adminTxnsRegBillerView = new AdminTxnsRegBillerView();
    this.billerPerformance = new BillerPerformance();
    this.adminTxnsStaticsView = new AdminTxnsStaticsView();
    this.topBillerResp = new TopBillerResp();
    this.adminPaymentSuccessRateView = new AdminPaymentSuccessRateView();
    this.viewAdminDashboard = new ViewAdminDashboard();
    this.adminPaymentTxnsAmountViewResp = new AdminPaymentTxnsAmountViewResp();
    this.adminPaymentTxnsAmountView = new AdminPaymentTxnsAmountView();
    this.inputOfVisitors = new InputOfVisitors();
    this.viewAdminDashboard.mode = 'web';
    this.getTodayWeekMonthYearDate('today');
  }

  disablePrevMonth(month) {
    let disable = false;
    if (this.currentMonthDate.getFullYear() === 2019 && month < 9) {
      disable = true;
    }
    return disable;
  }

  prevNextDailyReport(type) {
    let date = new Date(this.currentDate);

    switch (type) {
      case 'prev':
        date.setDate(this.currentDate.getDate() - 1);
        break;
      case 'next':
        date.setDate(this.currentDate.getDate() + 1);
        break;
      default:
        break;
    }

    this.currentDate = date;

    this.minDate.setHours(0, 0, 0, 0);
    this.today.setHours(0, 0, 0, 0);
    this.currentDate.setHours(0, 0, 0, 0);

    this.disablePrev =
      this.minDate.getTime() === this.currentDate.getTime() ? true : false;

    this.disableNext =
      this.today.getTime() <= this.currentDate.getTime() ? true : false;

    this.getTodayWeekMonthYearDate('today');
  }

  prevNextWeeklyReport(type) {
    let date = new Date(this.currentWeekDate);

    switch (type) {
      case 'prev':
        date.setDate(this.currentWeekDate.getDate() - 7);
        break;
      case 'next':
        date.setDate(this.currentWeekDate.getDate() + 7);
        break;
      default:
        break;
    }

    this.currentWeekDate = date;

    this.today.setHours(0, 0, 0, 0);
    this.currentWeekDate.setHours(0, 0, 0, 0);

    this.disableNextWeek =
      this.today.getTime() <= this.currentWeekDate.getTime() ? true : false;

    this.getTodayWeekMonthYearDate('week');
  }

  prevNextMonthReport(type, month, year) {
    let date = new Date(this.currentMonthDate);

    switch (type) {
      case 'prev':
        date.setMonth(this.currentMonthDate.getMonth() - 1);
        break;
      case 'next':
        date.setMonth(this.currentMonthDate.getMonth() + 1);
        break;
      default:
        date.setMonth(month);
        date.setFullYear(year);
        break;
    }

    this.currentMonthDate = date;

    this.selectedMonth = this.currentMonthDate.getMonth();
    this.selectedMonthYear = this.currentMonthDate.getFullYear();

    this.today.setHours(0, 0, 0, 0);
    this.currentMonthDate.setHours(0, 0, 0, 0);

    this.disableNextMonth =
      this.today.getTime() <= this.currentMonthDate.getTime() ? true : false;

    this.getTodayWeekMonthYearDate('month');
  }

  prevNextYearReport(type, year) {
    let date = new Date(this.currentYearDate);

    switch (type) {
      case 'prev':
        date.setFullYear(this.currentYearDate.getFullYear() - 1);
        break;
      case 'next':
        date.setFullYear(this.currentYearDate.getFullYear() + 1);
        break;
      default:
        date.setFullYear(year);
        break;
    }

    this.currentYearDate = date;
    this.selectedYear = this.currentYearDate.getFullYear();

    this.today.setHours(0, 0, 0, 0);
    this.currentYearDate.setHours(0, 0, 0, 0);

    this.disableNextYear =
      this.today.getTime() <= this.currentYearDate.getTime() ? true : false;

    this.getTodayWeekMonthYearDate('year');
  }

  getCurrentWeekDates() {
    let ws = new Date(this.getWeekRange(this.currentWeekDate).firstDay);
    let weekStartDate = ws.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });
    let wl = new Date(this.getWeekRange(this.currentWeekDate).lastDay);
    let weekLastDate = wl.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });

    return weekStartDate + ' - ' + weekLastDate;
  }

  getCurrentMonth() {
    return this.currentMonthDate.toLocaleDateString('en-US', {
      month: 'short',
      year: 'numeric',
    });
  }

  getTodayWeekMonthYearDate(valTime) {
    this.selectedOption = valTime;

    this.transactionAmount = 0;
    this.numberOfTrans = 0;
    this.isDataRefresh = false;
    let todayFrmtdDate = this.pipe.transform(new Date(), 'yyyy-MM-dd');

    let dailyDate = this.pipe.transform(this.currentDate, 'yyyy-MM-dd');
    // -----------------------week start n end date--------------

    let ws = new Date(this.getWeekRange(this.currentWeekDate).firstDay);
    let weekStartDate = this.pipe.transform(ws, 'yyyy-MM-dd');
    let wl = new Date(this.getWeekRange(this.currentWeekDate).lastDay);
    let weekLastDate = this.pipe.transform(wl, 'yyyy-MM-dd');

    // -----------------------month and start n end date--------------
    let monStrt = new Date(
      this.currentMonthDate.getFullYear(),
      this.currentMonthDate.getMonth(),
      1
    );
    let monthStartDate = this.pipe.transform(monStrt, 'yyyy-MM-dd');
    let monEnd = new Date(
      this.currentMonthDate.getFullYear(),
      this.currentMonthDate.getMonth() + 1,
      0
    );
    let monthLastDate = this.pipe.transform(monEnd, 'yyyy-MM-dd');

    let yStrt = new Date(this.currentYearDate.getFullYear(), 0, 1);
    let yearStartDate = this.pipe.transform(yStrt, 'yyyy-MM-dd');
    let yEnd = new Date(this.currentYearDate.getFullYear(), 11, 31);
    let yearEndDate = this.pipe.transform(yEnd, 'yyyy-MM-dd');
    let lastYearStrt = new Date(this.currentYearDate.getFullYear() - 1, 0, 1);
    let lastYearStartDate = this.pipe.transform(lastYearStrt, 'yyyy-MM-dd');
    let lastYearEnd = new Date(this.currentYearDate.getFullYear() - 1, 11, 31);
    let lastYearEndDate = this.pipe.transform(lastYearEnd, 'yyyy-MM-dd');

    this.customFlag = false;
    if (valTime == 'all') {
      this.activeAllFlag = true;
      this.activeYearFlag = false;
      this.activeLastYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.viewAdminDashboard.datafor = 'all';
      this.viewAdminDashboard.startdate = '2019-10-01'; //yearStartDate;
      this.viewAdminDashboard.enddate = todayFrmtdDate;
      this.textHeading = 'All';
    } else if (valTime == 'year') {
      this.activeAllFlag = false;
      this.activeYearFlag = true;
      this.activeLastYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.viewAdminDashboard.datafor = 'year';
      this.viewAdminDashboard.startdate = yearStartDate;
      this.viewAdminDashboard.enddate = yearEndDate;
      this.textHeading = 'This year\'s';
    } else if (valTime == 'lastYear') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeLastYearFlag = true;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.viewAdminDashboard.datafor = 'year';
      this.viewAdminDashboard.startdate = lastYearStartDate;
      this.viewAdminDashboard.enddate = lastYearEndDate;
      this.textHeading = 'Last year\'s';
    } else if (valTime == 'month') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeLastYearFlag = false;
      this.activeMonthFlag = true;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.viewAdminDashboard.datafor = 'month';
      this.viewAdminDashboard.startdate = monthStartDate;
      this.viewAdminDashboard.enddate = monthLastDate;
      //todo
      // this.viewAdminDashboard.startdate = '2024-07-01';
      // this.viewAdminDashboard.enddate = '2024-07-31';
      this.textHeading = 'This month\'s';
    } else if (valTime == 'week') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeLastYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = true;
      this.activeTodayFlag = false;
      this.viewAdminDashboard.datafor = 'week';
      this.viewAdminDashboard.startdate = weekStartDate;
      this.viewAdminDashboard.enddate = weekLastDate;
      this.textHeading = 'This week\'s';
    } else if (valTime == 'today') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeLastYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = true;
      this.viewAdminDashboard.datafor = 'today';
      this.viewAdminDashboard.startdate = dailyDate;
      //TODO
      // this.viewAdminDashboard.startdate = '2024-08-27';
      this.textHeading = 'Today\'s';
    }
    this.getAdminTxnsDashboardGraphDataView();
    this.getAdminTxnsDashboardReportView();
    this.getAdminPaymentKeyperFormanceIndicatorView();
    this.getAdminTxnsStaticsView();
    this.getAdminTxnsRegCitizenView();
    this.getAdminTxnsRegBillerView();
    this.getAdminTopRecordsView();
    this.getNumberOfVisitor();
    this.getAdminPaymentSuccessRateViewPi();
    this.getAdminPaymentTxnsAmountViewPi();
    this.getAdminPaymentSuccessRateViewPm();
    // this.getAdminPaymentTxnsAmountViewPm();
    this.getAdminBillerPerformanceView();
    this.getAssistedTransaction();
  }

  getWeekRange(selectedDate) {
    const today = new Date(selectedDate);

    // Get the current day of the week (0 - Sunday, 6 - Saturday)
    const currentDayOfWeek = today.getDay();

    // Calculate the difference to get to Sunday (start of the week)
    const firstDayDiff = currentDayOfWeek;
    const lastDayDiff = 6 - currentDayOfWeek;

    // Calculate the first and last day of the week
    const firstDayOfWeek = new Date(today);
    const lastDayOfWeek = new Date(today);

    firstDayOfWeek.setDate(today.getDate() - firstDayDiff);
    lastDayOfWeek.setDate(today.getDate() + lastDayDiff);

    return {
      firstDay: firstDayOfWeek,
      lastDay: lastDayOfWeek,
    };
  }

  isLoaderOff() {
    // this.loaderService.hide();
  }

  //----------------------------------TRANSACTION AND AMOUNT BAR CHART 1-------------------------------------

  // sets the total number of transactions and total number of transaction amount
  getNumberOfTransaction(arrayOfTrans: number[], arrayOfAmount: number[]) {
    this.numberOfTrans = 0;
    this.transactionAmount = 0;

    for (let i = 0; i < arrayOfTrans.length; i++) {
      this.numberOfTrans += arrayOfTrans[i];
    }

    // //this.logger.debug('transaction no in admin......... ' + this.numberOfTrans);
    for (let i = 0; i < arrayOfAmount.length; i++) {
      this.transactionAmount += arrayOfAmount[i];
    }
    //this.logger.debug('transaction no in admin......... ' + this.transactionAmount);
  }

  getAdminTxnsDashboardGraphDataView() {
    this.isGetTxsnUpdate = false;
    this.isRefresh = false;
    this.viewAdminTxnsDashboardGraphDataResponse =
      new ViewAdminTxnsDashboardGraphDataResponse();
    this.serviceAdmin
      .getAdminTxnsDashboardGraphDataView(this.viewAdminDashboard)
      .subscribe((data) => {
        this.isGetTxsnUpdate = true;
        this.isRefresh = true;
        //console.log("wow  ", this.viewAdminTxnsDashboardGraphDataResponse);
        this.viewAdminTxnsDashboardGraphDataResponse =
          data.body as ViewAdminTxnsDashboardGraphDataResponse;
        // console.log('wow  ', this.viewAdminTxnsDashboardGraphDataResponse);
        this.getNumberOfTransaction(
          this.viewAdminTxnsDashboardGraphDataResponse.txns,
          this.viewAdminTxnsDashboardGraphDataResponse.amount
        );
        this.barChartData = [
          //value for y axis.....the dataset for the barchart
          {
            data: this.viewAdminTxnsDashboardGraphDataResponse.txns,
            label: 'No. of Transactions',
            yAxisID: '1',
            fill: true,
          },
          {
            data: this.viewAdminTxnsDashboardGraphDataResponse.amount,
            label: 'Total Amount',
            yAxisID: '2',
            fill: true,
          },
        ];
        this.barChartLabels =
          this.viewAdminTxnsDashboardGraphDataResponse.timeperiod;
      });
  }

  public chartClicked(e: any): void {
    // console.log(e);
  }

  public chartHovered(e: any): void {
    // console.log(e);
  }

  //----------------------------------STATICS PIE CHART 1 DONE-----------------------------------------
  public pieChartLabels: string[] = [
    'Total Visitors',
    'Bill Fetch',
    'Bill Paid',
    'Successful Transactions',
  ];
  public pieChartType: string = 'pie';
  public pieChartColors: Array<any> = [
    {
      backgroundColor: ['#0d9b8c', '#ff9900', '#8f3e92', '#7cb62c'],
      borderColor: ['#0d9b8c', '#ff9900', '#8f3e92', '#7cb62c'],
    },
  ];

  getAdminTxnsStaticsView() {
    this.isTxsnStaticsUpdate = false;
    this.pieChartData = [];
    this.serviceAdmin
      .getAdminTxnsStaticsView(this.viewAdminDashboard)
      .subscribe((data) => {
        this.isTxsnStaticsUpdate = true;
        this.adminTxnsStaticsView = data.body as AdminTxnsStaticsView;
        this.pieChartData = [
          this.adminTxnsStaticsView.total_visitors,
          this.adminTxnsStaticsView.bill_fetch,
          this.adminTxnsStaticsView.bill_paid,
          this.adminTxnsStaticsView.success_txns,
        ];
      });
  }

  public chartPieClicked(e: any): void {
    // console.log(e);
  }

  public chartPieHovered(e: any): void {
    // console.log(e);
  }

  //--------------------------------NUMBER OF VISITORS LINE CHART 1------------------------------------------
  // public lineChartData: Array<any> = [
  //   { data: [65, 59, 80, 81, 56, 55, 40], label: 'No. of Visitors' },
  // ];
  // public lineChartLabels: Array<any> = ['Mar 24', 'Mar 25', 'Mar 26', 'Mar 27', 'Mar 28', 'Mar 29', 'Mar 30'];
  public lineChartLegend: boolean = true;
  public lineChartType: string = 'bar';
  public lineChartOptions: any = {
    tooltips: {
      intersect: false,
      mode: 'index'
    },
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    spanGaps: true,
    fill: false,
    scales: {
      xAxes: [
        {
          maxRotation: 90,
          // minRotation: 90,
          ticks: {
            autoSkip: false,
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Number of Visitors',
            fontSize: 16,
            fontColor: 'rgba(0,191,165,1)',
          },
          ticks: this.dashboardService.customTicks,
        },
      ],
    },
  };
  public lineChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(113,255,238,0.5)',
      borderColor: 'rgb(1,222,193)',
      pointBackgroundColor: 'rgba(0,191,165,1)',
      pointBorderColor: 'rgba(0,191,165,1)',
      pointHoverBackgroundColor: 'rgba(0,191,165,1)',
      pointHoverBorderColor: 'rgba(0,191,165,1)',
    },
  ];

  // public chartLineClicked(e: any): void {
  //   //console.log(e);
  // }

  // public chartLineHovered(e: any): void {
  //   //console.log(e);
  // }

  getNumberOfVisitor() {
    this.isVisitorUpdate = false;
    this.inputOfVisitors.data_for = this.viewAdminDashboard.datafor;
    this.inputOfVisitors.start_date = this.viewAdminDashboard.startdate;
    this.inputOfVisitors.end_date = this.viewAdminDashboard.enddate;
    this.inputOfVisitors.mode = this.viewAdminDashboard.mode;
    // alert(JSON.stringify(this.inputOfVisitors));
    this.serviceAdmin
      .getNumberOfVisitor(this.inputOfVisitors)
      .subscribe((data) => {
        // console.log('line chart ', data);
        this.numberOfVisitors = data.body as NumberOfVisitors;
        this.isVisitorUpdate = true;
        this.lineChartData = [
          {
            data: this.numberOfVisitors.no_of_visitors,
            label: 'Number of Visitors',
          },
        ];
        this.lineChartLabels = this.numberOfVisitors.date_hour;
      });
  }

  //--------------------------------------LINE CHART 2--------------------------------------------
  public hollowLineChartType: string = 'bar'; //line
  public hollowChartOptions: any = {
    tooltips: {
      intersect: false,
      mode: 'index'
    },
    type: 'bar', //line
    maintainAspectRatio: false,
    responsive: true,
    // fill: true,
    fillColor: '#e91e63',
    scales: {
      xAxes: [
        {
          ticks: {
            maxRotation: 90,
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Transaction Amount',
            fontSize: 16,
            fontColor: '#e91e63',
          },
          ticks: this.dashboardService.customTicks2,
        },
      ],
    },
  };
  public hollowChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(233,30,99,0.5)',
      borderColor: '#e91e63',
      pointBackgroundColor: '#e91e63',
      pointBorderColor: '#e91e63',
      pointHoverBackgroundColor: '#e91e63',
      pointHoverBorderColor: '#e91e63',
    },
  ];

  getAdminPaymentTxnsAmountViewPi() {
    this.isPITxsnUpdate = false;
    this.adminPaymentTxnsAmountView.type = 'pi';
    this.adminPaymentTxnsAmountView.datafor = this.viewAdminDashboard.datafor;
    this.adminPaymentTxnsAmountView.startdate =
      this.viewAdminDashboard.startdate;
    this.adminPaymentTxnsAmountView.enddate = this.viewAdminDashboard.enddate;
    this.adminPaymentTxnsAmountView.mode = this.viewAdminDashboard.mode;
    //alert(JSON.stringify(this.adminPaymentTxnsAmountView));

    this.serviceAdmin
      .getAdminPaymentTxnsAmountView(this.adminPaymentTxnsAmountView)
      .subscribe((data) => {
        this.isPITxsnUpdate = true;

        this.adminPaymentTxnsAmountViewResp =
          data.body as AdminPaymentTxnsAmountViewResp;
        this.hollowLineChartData = [
          {
            data: this.adminPaymentTxnsAmountViewResp.total_amount,
            label: 'Transaction Amount',
            fill: false,
          },
        ];
        this.hollowLineChartLabels =
          this.adminPaymentTxnsAmountViewResp.payment_name;
        const index = this.hollowLineChartLabels.indexOf(
          'Bank Asia Internet Banking'
        );
        if (index > -1) {
          this.hollowLineChartLabels[index] = 'Bank Asia IB';
        }
        // console.log(this.hollowLineChartLabels);
      });
  }

  public hollowLineClicked(e: any): void {
    // console.log(e);
  }

  public hollowLineHovered(e: any): void {
    // console.log(e);
  }

  //--------------------------------3Rd LINE CHART-------------------------------------------
  // public lineSFChartData: Array<any> =
  // [
  //   { data: [10, 10, 5, 4, 1, 7, 8, 2, 6, 8, 6, 4, 9, 5, 4], label: 'Failure' },
  //   { data: [90, 90, 95, 96, 99, 93, 92, 98, 94, 92, 94, 91, 95, 96, 99], label: 'Success' }
  // ];
  // public lineSFChartLabels: Array<any> = ['EBL', 'DBBL', 'City Bank', 'BRAC Bank', 'BKash', 'Rocket', 'Bank Asia', 'IBBL', 'PAYZA', 'DMoney', 'IPay', 'QCash', 'RFID', 'SEBL', 'UCBL'];
  public lineSFChartType: string = 'bar'; //line
  public lineSFChartOptions: any = {
    tooltips: {
      intersect: false,
      mode: 'index'
    },
    type: 'bar', //line
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [
        {
          ticks: {
            maxRotation: 90,
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Rate ( in Percentage )',
            fontSize: 12,
            fontColor: '#0d9b8c',
          },
          ticks: {min: 0, beginAtZero: true, fontSize: 10},
        },
      ],
    },
  };
  public lineSFChartColors: Array<any> = [
    {
      backgroundColor: '#00cc1d',
      borderColor: '#29ff48',
      pointBackgroundColor: '#29ff48',
      pointBorderColor: '#29ff48',
      pointHoverBackgroundColor: '#29ff48',
      pointHoverBorderColor: '#29ff48',
    },
    {
      backgroundColor: 'rgba(233,30,99,0.5)',
      borderColor: 'rgba(233,30,99,1)',
      pointBackgroundColor: '#e91e63',
      pointBorderColor: '#e91e63',
      pointHoverBackgroundColor: '#e91e63',
      pointHoverBorderColor: '#e91e63',
    },
  ];

  getAdminPaymentSuccessRateViewPi() {
    this.isPISuccFailUpdate = false;
    this.adminPaymentTxnsAmountView.startdate =
      this.viewAdminDashboard.startdate;
    this.adminPaymentTxnsAmountView.enddate = this.viewAdminDashboard.enddate;
    this.adminPaymentTxnsAmountView.datafor = this.viewAdminDashboard.datafor;
    this.adminPaymentTxnsAmountView.mode = this.viewAdminDashboard.mode;
    this.adminPaymentTxnsAmountView.type = 'pi';
    this.serviceAdmin
      .getAdminPaymentSuccessRateView(this.adminPaymentTxnsAmountView)
      .subscribe((data) => {
        this.isPISuccFailUpdate = true;
        this.adminPaymentSuccessRateView =
          data.body as AdminPaymentSuccessRateView;
        this.lineSFChartData = [
          {
            data: this.adminPaymentSuccessRateView.success,
            label: 'Success',
          },
          {
            data: this.adminPaymentSuccessRateView.fail,
            label: 'Failure',
          },
        ];
        this.lineSFChartLabels = this.adminPaymentSuccessRateView.payment_name;
      });
  }

  //---------------------------------4th LINE CHART-------------------------------
  // public LinePIChartData: Array<any>  =
  //   [
  //     { data: [40000, 70000, 30000, 20000, 30000, 5000, 70000, 45000, 35000, 90000], label: 'Transaction Amount' },
  //   ];
  // public LinePIChartLabels: Array<any> = ['VISA', 'MASTER', 'AMEX', 'NEXUS', 'DINERS', 'MFS', 'E-BANKING', 'WALLET', 'ITCL', 'RFID'];
  public LinePIChartType: string = 'bar';
  line;
  public ChartPIOptions: any = {
    type: 'bar', //line
    tooltips: {
      intersect: false,
      mode: 'index'
    },
    maintainAspectRatio: false,
    // spanGaps: true,
    responsive: true,
    fill: true,
    fillColor: '7f93dc',
    // elements: {
    //   line: {
    //     tension: 0.000001
    //   }
    // },
    // plugins: {
    //   filler: {
    //     propagate: false
    //   }
    // },
    scales: {
      xAxes: [
        {
          ticks: {
            maxRotation: 90,
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Transaction Amount',
            fontSize: 16,
            fontColor: '#7f93dc',
          },
          ticks: this.dashboardService.customTicks,
        },
      ],
    },
  };
  public LinePIChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(127,147,220,0.5)',
      borderColor: '#7f93dc',
      pointBackgroundColor: '#7f93dc',
      pointBorderColor: 'white',
      pointHoverBackgroundColor: '#7f93dc',
      pointHoverBorderColor: '#7f93dc',
    },
  ];

  // getAdminPaymentTxnsAmountViewPm() {
  //   this.isPMTxsnUpdate = false;
  //   this.adminPaymentTxnsAmountView.type = 'pm';
  //   this.adminPaymentTxnsAmountView.datafor = this.viewAdminDashboard.datafor;
  //   this.adminPaymentTxnsAmountView.startdate = this.viewAdminDashboard.startdate;
  //   this.adminPaymentTxnsAmountView.enddate = this.viewAdminDashboard.enddate;
  //   this.adminPaymentTxnsAmountView.mode = this.viewAdminDashboard.mode;
  //   this.serviceAdmin.getAdminPaymentTxnsAmountView(this.adminPaymentTxnsAmountView).subscribe((data) => {
  //     this.isPMTxsnUpdate = true;
  //     this.adminPaymentTxnsAmountViewResp = data.body as AdminPaymentTxnsAmountViewResp;
  //     this.LinePIChartData = [
  //       {data: this.adminPaymentTxnsAmountViewResp.total_amount, label: 'Transaction Amount', fill: false}
  //     ];
  //     this.LinePIChartLabels = this.adminPaymentTxnsAmountViewResp.payment_name;
  //   });
  // }

  public LinePIClicked(e: any): void {
    // console.log(e);
  }

  public LinePIHovered(e: any): void {
    // console.log(e);
  }

  // ---------------------5th LINE CHART-------------------------------
  // public linePISFChartData: Array<any> =
  //   [
  //     { data: [0, 7, 3, 12, 8, 5, 9, 11, 4, 8], label: 'Failure' },
  //     { data: [100, 93, 97, 88, 92, 95, 91, 89, 96, 92], label: 'Success', fill: false }
  //   ];
  // public linePISFChartLabels: Array<any> = ['VISA', 'MASTER', 'AMEX', 'NEXUS', 'DINERS', 'MFS', 'E-BANKING', 'WALLET', 'ITCL', 'RFID'];
  public linePISFChartType: string = 'bar'; //line
  public linePISFChartOptions: any = {
    type: 'bar', //line
    tooltips: {
      intersect: false,
      mode: 'index'
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [
        {
          ticks: {
            maxRotation: 90,
            fontSize: 10,
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Rate ( in Percentage )',
            fontSize: 10,
            fontColor: '#ff9900',
          },
          ticks: {min: 0, beginAtZero: true, fontSize: 10},
        },
      ],
    },
  };
  public linePISFChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(0,191,165,0.5)',
      borderColor: 'rgba(0,191,165,1)',
      pointBackgroundColor: 'rgba(0,191,165,1)',
      pointBorderColor: 'rgba(0,191,165,1)',
      pointHoverBackgroundColor: 'rgba(0,191,165,1)',
      pointHoverBorderColor: 'rgba(0,191,165,1)',
    },
    {
      backgroundColor: 'rgba(255,153,0,1)',
      borderColor: 'rgba(255,153,0,1)',
      pointBackgroundColor: 'rgba(255,153,0,1)',
      pointBorderColor: 'rgba(255,153,0,1)',
      pointHoverBackgroundColor: 'rgba(255,153,0,1)',
      pointHoverBorderColor: 'rgba(255,153,0,1)',
    },
  ];

  getAdminPaymentSuccessRateViewPm() {
    this.isPMSuccFailUpdate = false;
    this.adminPaymentTxnsAmountView.startdate =
      this.viewAdminDashboard.startdate;
    this.adminPaymentTxnsAmountView.enddate = this.viewAdminDashboard.enddate;
    this.adminPaymentTxnsAmountView.datafor = this.viewAdminDashboard.datafor;
    this.adminPaymentTxnsAmountView.mode = this.viewAdminDashboard.mode;
    this.adminPaymentTxnsAmountView.type = 'pm';
    this.serviceAdmin
      .getAdminPaymentSuccessRateView(this.adminPaymentTxnsAmountView)
      .subscribe((data) => {
        this.isPMSuccFailUpdate = true;
        this.adminPaymentSuccessRateView =
          data.body as AdminPaymentSuccessRateView;
        this.linePISFChartData = [
          {
            data: this.adminPaymentSuccessRateView.success,
            label: 'Success',
          },
          {
            data: this.adminPaymentSuccessRateView.fail,
            label: 'Failure',
          },
        ];
        this.linePISFChartLabels =
          this.adminPaymentSuccessRateView.payment_name;
      });
  }

  //----------------------------------Biller Performance 2nd BAR CHART-------------------------------
  public barChart2Type: string = 'bar';
  public barChart2Legend: boolean = true;

  public barChart2Options: any = {
    tooltips: {
      intersect: false,
      mode: 'index'
    },
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'No. of Transactions',
            fontSize: 16,
            fontColor: '#8f3e92',
          },
          position: 'left',
          id: '1',
          type: 'linear',
          ticks: this.dashboardService.customTicks,
        },
        {
          scaleLabel: {
            display: true,
            labelString: 'Total Amount (in BDT)',
            fontSize: 16,
            fontColor: '#88c133',
          },
          position: 'right',
          id: '2',
          type: 'linear',
          ticks: this.dashboardService.customTicks,
        },
      ],
      xAxes: [
        {
          ticks: {
            maxRotation: 90,
          },
        },
      ],
    },
  };

  // public barChart2Options: any = {
  //   tooltips: {
  //     intersect: false,
  //     mode: 'index'
  //   },
  //   type: 'bar',
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   //spanGaps: true,
  //   scaleShowVerticalLines: false,
  //   // legend: { display: false },
  //   scales: {
  //     xAxes: [
  //       {
  //         ticks: {
  //           maxRotation: 90,
  //         },
  //       },
  //     ],
  //     yAxes: [
  //       {
  //         scaleLabel: {
  //           display: true,
  //           labelString: "No. of Transactions",
  //           fontSize: 15,
  //           fontColor: "rgba(136,193,51,1)",
  //         },
  //         ticks: this.dashboardService.customTicks,
  //       },
  //     ],
  //   },
  // };

  public assistedChart2Options: any = {
    tooltips: {
      intersect: false,
      mode: 'index'
    },
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    //spanGaps: true,
    scaleShowVerticalLines: false,
    // legend: { display: false },
    scales: {
      xAxes: [
        {
          ticks: {
            maxRotation: 90,
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Total Amount in BDT',
            fontSize: 15,
            fontColor: 'rgba(136,193,51,1)',
          },
          ticks: this.dashboardService.customTicks,
        },
      ],
    },
  };

  public getRandomColor() {
    var letters = '0123456789ABCDEF'.split('');
    for (var i = 0; i < 6; i++) {
      this.color += letters[Math.floor(Math.random() * 16)];
    }
    return this.color;
  }

  public barChart2Colors: Array<any> = [
    {
      backgroundColor: [
        'rgb(89,98,134,0.5)',
        'rgba(125,14,22,0.5)',
        'rgba(0,50,255,0.5)',
        'rgba(255,0,85,0.5)',
        'rgba(255,144,0,0.5)',
        'rgba(9,129,109,0.5)',
        'rgba(0,151,165,0.5)',
        'rgba(0,121,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
      ],
    },
    {
      backgroundColor: [
        'rgb(63,168,217,0.5)',
        'rgba(232,61,86,0.5)',

        'rgba(127,147,220,0.5)',
        'rgba(233,30,99,0.5)',
        'rgba(255,185,89,0.5)',
        'rgba(0,191,165,0.5)',
        'rgba(0,151,165,0.5)',
        'rgba(0,121,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
        'rgba(0,111,165,0.5)',
      ]
    },

  ];

  getAdminBillerPerformanceView() {
    this.idBillerPerUpdate = false;
    this.serviceAdmin
      .getAdminBillerPerformanceView(this.viewAdminDashboard)
      .subscribe((data) => {
        this.idBillerPerUpdate = true;
        this.billerPerformance = data.body as BillerPerformance;
        this.barChart2Data = [
          //value for y axis.....the dataset for the barchart
          {
            data: this.billerPerformance.no_of_txns,
            label: 'No. of transaction',
            yAxisID: '1',
            fill: true,
          },
          {
            data: this.billerPerformance.total_amount,
            label: 'Total Amount',
            yAxisID: '2',
            fill: true,
          },
        ];
        // this.barChart2Data = [
        //   {
        //     data: this.billerPerformance.no_of_txns,
        //     label: "No. of transaction",
        //   },
        // ];
        this.barChart2Labels = this.billerPerformance.blr_name;
        this.isDataRefresh = true;
      });
  }

  getAssistedTransaction() {
    //console.log("assisetd graph called")
    this.isAssistedUpdate = false;
    this.serviceAdmin
      .getAssistedPerformanceView(this.adminPaymentTxnsAmountView)
      .subscribe((data) => {
        this.isAssistedUpdate = true;
        this.assistedPerformance = data.body as AssistedPerformance;
        // this.barChartAssistedData = [
        //   {
        //     data: this.assistedPerformance.total_amount,
        //     label: "Total amount of transaction",
        //   },
        // ];

        this.barChartAssistedData = [
          //value for y axis.....the dataset for the barchart
          {
            data: this.assistedPerformance.no_of_txns,
            label: 'No. of transaction',
            yAxisID: '1',
            fill: true,
          },
          {
            data: this.assistedPerformance.total_amount,
            label: 'Total Amount',
            yAxisID: '2',
            fill: true,
          },
        ];
        this.barChartAssistedLabels = this.assistedPerformance.payment_name;
        this.isDataRefresh = true;
      });
  }

  public chart2Clicked(e: any): void {
    // console.log(e);
  }

  public chart2Hovered(e: any): void {
    // console.log(e);
  }

  // -------------------------- Tabular registers biller ---------------------------
  getAdminTxnsDashboardReportView() {
    this.isTxsnReportUpdate = false;
    this.serviceAdmin
      .getAdminTxnsDashboardReportView(this.viewAdminDashboard)
      .subscribe((data) => {
        this.isTxsnReportUpdate = true;
        // console.log('billers  ', data);
        this.viewAdminDashboardResponse =
          data.body as ViewAdminDashboardResponse;
      });
  }

  // -------------------Key Performace Indicator------------------------------
  getAdminPaymentKeyperFormanceIndicatorView() {
    this.isKeyPerUpdate = false;
    this.serviceAdmin
      .getAdminPaymentKeyperFormanceIndicatorView(this.viewAdminDashboard)
      .subscribe((data) => {
        this.isKeyPerUpdate = true;
        // console.log('performance  ', data);
        this.adminPaymentKeyperFormanceIndicatorView =
          data.body as AdminPaymentKeyperFormanceIndicatorView;
      });
  }

  //----------------------fetch admin txns reg citizen-----------------
  totalCitizenReg: number = 0;

  getAdminTxnsRegCitizenView() {
    this.isRegCitizenUpdate = false;
    this.serviceAdmin
      .getAdminTxnsRegCitizenView(this.viewAdminDashboard)
      .subscribe((data) => {
        this.isRegCitizenUpdate = true;
        // console.log('citizen  ', data);
        this.totalCitizenReg = data.body.reg_citizen;
      });
  }

  // ---------------------EkPay Registered Billers-----------------------
  getAdminTxnsRegBillerView() {
    this.isRecentTransaction = false;
    this.isRegBillerUpdate = false;
    this.serviceAdmin
      .getAdminTxnsRegBillerView(this.viewAdminDashboard)
      .subscribe((data) => {
        this.isRegBillerUpdate = true;
        this.adminTxnsRegBillerView = data.body as AdminTxnsRegBillerView;
        // console.log(this.adminTxnsRegBillerView);
        if (this.adminTxnsRegBillerView.registered_billers == null) {
          this.isRecentTransaction = true;
        }
      });
  }

  // --------------------------fetch admin top records------------------
  getAdminTopRecordsView() {
    let topBiller = new TopBiller();
    this.isTopRecordUpdate = false;
    this.isTopBillerAvail = false;
    topBiller.datafor = this.viewAdminDashboard.datafor;
    topBiller.startdate = this.viewAdminDashboard.startdate;
    topBiller.enddate = this.viewAdminDashboard.enddate;
    topBiller.mode = this.viewAdminDashboard.mode;
    topBiller.recordfor = 'biller';
    this.serviceAdmin.getAdminTopRecordsView(topBiller).subscribe((data) => {
      this.isTopRecordUpdate = true;
      this.loaderOff = 1;
      if (this.loaderOff == 1) {
        this.isLoaderOff();
      }
      this.topBillerResp = data.body as TopBillerResp;
      if (this.topBillerResp.top_records.length == 0) {
        this.isTopBillerAvail = true;
      }
    });
  }

  viewUser() {
    this.router.navigate(['/user/view']);
  }

  viewBiller() {
    this.router.navigate(['/biller/views']);
  }

  onCustom() {
    this.selectedOption = 'custom';
    this.customFlag = true;
    this.activeAllFlag = false;
    this.activeYearFlag = false;
    this.activeMonthFlag = false;
    this.activeWeekFlag = false;
    this.activeTodayFlag = false;
    this.activeLastYearFlag = false;
  }

  chartSFHovered($event: any) {
  }

  chartSFClicked($event: any) {
  }

  chartPISFHovered($event: any) {
  }

  chartPISFClicked($event: any) {
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboards/admin-dashboard/admin-dashboard.component.ts